import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const COMPANY_NAME = "NetBasis International";

const title = "Full-Service-Angebot";
const h1Text = "Ihr strategischer und operativer Partner für ein umfassendes Full-Service-Paket in der DACH-Region. Als verlängerter Arm übernehmen wir Ihr gesamtes lokales Geschäft, damit Sie den Kopf frei für Ihre Heimatmärkte behalten.";
const heroImage = "https://net-basis.net/Bilder/ict-full-service-business-development-management.webp";
const heroAlt = "Geschäftsmann bedient digitales Dashboard für ein zentral gesteuertes ITK-Full-Service-Angebot.";
const heroClaimLine1 = "Alles aus";
const heroClaimLine2 = "einer Hand!";
const benefitsTitle = "Wie Sie von unserer Expertise im Bereich __Full-Service-Angebot__ profitieren:";

const p1Text = "NetBasis International arbeitet für ausländische Unternehmen als feste Instanz in den für sie neuen Märkten. Aus einem breit gefächerten Portfolio an Dienstleistungen können unsere Herstellerpartner individuell und auf ihre unternehmensspezifischen Anforderungen zugeschnitten einzelne Services auswählen.";
const p2Text = "Der umfassendste Ansatz allerdings, einen neuen Markt zu betreten, und somit der beste Weg, eine erfolgreiche Arbeit sicherzustellen, ist unser Full-Service-Paket. Dabei behalten unsere Herstellerpartner den Kopf frei für das Geschäft in ihren Heimatmärkten und überlassen, natürlich in enger Kooperation, NetBasis International die komplette Betreuung der neuen Märkte.";
const p3Text = "Mit einem Full-Service-Vertrag übernimmt NetBasis International das gesamte lokale Geschäft sowie die Planung, Abwicklung und Überwachung aller anfallenden Aufgaben.";

const p1Parts = p1Text.split(COMPANY_NAME);
const p2Parts = p2Text.split(COMPANY_NAME);
const p3Parts = p3Text.split(COMPANY_NAME);

const sections = [
  {
    title: "1. Alles inklusive",
    items: [
      "Postalische Adresse und kompletter Büroservice vor Ort",
      "Technische und kaufmännische Evaluation Ihrer Produkte",
      "Erstellung aller notwendigen kaufmännischen und technischen Dokumente",
      "Intensive und fundierte Wettbewerbsanalyse im Zielmarkt",
      "Strategische Preisgestaltung und Marktpositionierung",
      "Vermarktung ausgewählter oder aller Produkte und Lösungen als Ihr Importeur",
      "Offizielle Registrierung oder Meldung von Hardware-Produkten bei Behörden wie der Stiftung EAR",
      "Zuverlässiger technischer Support nach klar definierten Service-Levels",
      "Wir von NetBasis International entwickeln Ihr Geschäft als Ihre lokale Repräsentanz",
    ],
  },
  {
    title: "2. Praxisnah",
    items: [
      "Ein zentraler Ansprechpartner für Ihre Anliegen sowie für Ihre Kunden vor Ort in Englisch und Deutsch",
      "Kompletter Vertrieb, zielgerichtetes Marketing und Support in Ihrem Namen direkt im Markt",
    ],
  },
  {
    title: "3. Schnell",
    items: [
      "Keine lange Anlaufphase – mit uns sind Sie sofort einsatzbereit und \"ready for action\"",
      "Direkte Konzentration auf die eigentliche, produktive Arbeit vor Ort",
      "Keine Verzögerung beim Kontaktieren potenzieller Kunden oder qualifizierter Vertriebspartner",
      "Unkomplizierte lokale Kundenbetreuung, Kundenbesuche und professionelle Messeteilnahmen",
    ],
  },
  {
    title: "4. Nah am Kunden",
    items: [
      "Vor Ort präsent ohne sprachliche oder kulturelle Barrieren",
      "Professionelle, erfahrene, verlässliche und kundenorientierte Außenwirkung",
      "Hohe unternehmerische Agilität und extrem kurze Reaktionszeiten",
    ],
  },
  {
    title: "5. Kostengünstig",
    items: [
      "Keine Kosten für ein teures internationales Büro und Personal – minimale Fixkosten ohne hohe Investitionen",
      "Klare und tragbare monatliche Pauschalgebühren plus Erfolgsprovision entsprechend der Partnervereinbarung",
    ],
  },
];

const bottomClaim = "NetBasis International - drive to excellence with excellent drivers !";

export default function FullServiceAngebotDePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Full-Service-Angebot | NetBasis International"
        description="Von der Marktanalyse bis zum Vertrieb: Unser modulares Komplettpaket für Ihren schlüsselfertigen internationalen Markterfolg."
        ogUrl="https://net-basis.net/de/services/business-development/full-service-angebot"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src={heroImage}
                alt={heroAlt}
                title={title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

              <div className="absolute inset-0 z-20 flex items-start justify-end pt-[12%] md:pt-[4%] lg:pt-[4%] pr-[8%] md:pr-[4%] pointer-events-none">
                <p
                  className="text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-right leading-[1.15] md:leading-[1.5] animate-[presenceTextSlide_12s_ease-in-out_infinite]"
                  style={{
                    fontFamily: '"Open Sans", sans-serif',
                  }}
                >
                  <span className="block md:inline">{heroClaimLine1}</span>
                  {heroClaimLine2 && <span className="hidden md:inline"> </span>}
                  {heroClaimLine2 && <span className="block md:inline">{heroClaimLine2}</span>}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {title}
            </h2>

            <h1 className="font-semibold text-foreground-950 text-sm md:text-base mb-4">
              {h1Text}
            </h1>

            <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
              <p>
                {p1Parts.map((part, i) => (
                  <span key={i}>
                    {part}
                    {i < p1Parts.length - 1 && (
                      <strong className="text-primary-600">{COMPANY_NAME}</strong>
                    )}
                  </span>
                ))}
              </p>
              <p>
                {p2Parts.map((part, i) => (
                  <span key={i}>
                    {part}
                    {i < p2Parts.length - 1 && (
                      <strong className="text-primary-600">{COMPANY_NAME}</strong>
                    )}
                  </span>
                ))}
              </p>
              <p>
                {p3Parts.map((part, i) => (
                  <span key={i}>
                    {part}
                    {i < p3Parts.length - 1 && (
                      <strong className="text-primary-600">{COMPANY_NAME}</strong>
                    )}
                  </span>
                ))}
              </p>
            </div>

            {/* Green heading with italic word */}
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mt-8 md:mt-10 mb-5 md:mb-7">
              {benefitsTitle.split("__").map((part, i) =>
                i % 2 === 1 ? <em key={i}>{part}</em> : part
              )}
            </h2>

            {/* Sections with green sub-headings and bullet lists */}
            <div className="space-y-5 text-foreground-950 leading-relaxed text-sm md:text-base">
              {sections.map((section, idx) => (
                <div key={idx}>
                  <h3 className="text-primary-600 font-bold text-sm md:text-base mb-2">
                    {section.title}
                  </h3>
                  <ul className="list-disc pl-5 space-y-1">
                    {section.items.map((item, j) => (
                      <li key={j}>{item}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}